<template>
  <key-number-input
    :value="keyLength"
    :isValid="isKeyLengthValid"
    label="Délka klíče"
    invalidFeedback="Délka klíče musí být v rozmezí 2-16"
    @valueChanged="keyLengthChanged"
  />

  <num-of-words-input
    :value="numOfWords"
    :isValid="isNumOfWordsValid"
    label="Počet slov v klíči"
    invalidFeedback="Nesprávný počet slov v klíči"
    @valueChanged="numOfWordsChanged"
  />

  <cipher-text-area
    :value="cipherText"
    :isValid="isCipherTextValid"
    invalidFeedback="Zadej šifrový text pro prolomení"
    @valueChanged="cipherTextChanged"
  />

  <button @click="solve" class="danger-btn">Prolomit</button>
  <button @click="toggleSettings" class="special-btn">Nastavení</button>

  <div v-show="settingsShown">
    <solve-settings
      :value="numOfIterations"
      @valueChanged="numOfIterationsChanged"
      :max="1000"  
    />
  </div>

  <div v-show="isSolving" class="solve-alert">Probíhá prolamování...</div>

  <solve-results :results="results" />
</template>

<script>
import KeyNumberInput from '@/components/input/KeyNumberInput'
import CipherTextArea from '@/components/input/CipherTextArea'
import SolveSettings from '@/components/solve/SolveSettings'
import SolveResults from '@/components/solve/SolveResults'

import { solveUbchi } from '@/solve/ubchi.worker.js'

export default {
  components: {
    'key-number-input': KeyNumberInput,
    'num-of-words-input': KeyNumberInput,
    'cipher-text-area': CipherTextArea,
    'solve-settings': SolveSettings,
    'solve-results': SolveResults
  },
  data() {
    return {
      keyLength: 10,
      numOfWords: 1,
      cipherText: '',
      numOfIterations: 10,
      results: [],
      settingsShown: false,
      isSolving: false
    }
  },
  methods: {
    keyLengthChanged(value) {
      this.keyLength = value
    },
    numOfWordsChanged(value) {
      this.numOfWords = value
    },
    cipherTextChanged(value) {
      this.cipherText = value
      this.results = []
    },
    solve() {
      if (this.isSolving || this.numOfIterations == 0) return

      if (this.isKeyLengthValid && this.isNumOfWordsValid && this.isCipherTextValid) {
        this.isSolving = true
        solveUbchi(this.cipherText, this.keyLength, this.numOfWords, this.numOfIterations)
          .then(result => {
            this.results.push(result)
            this.isSolving = false
          })
      }
    },
    toggleSettings() {
      this.settingsShown = !this.settingsShown
    },
    numOfIterationsChanged(value) {
      this.numOfIterations = value
    }
  },
  computed: {
    isKeyLengthValid() {
      return this.keyLength >= 2 && this.keyLength <= 16
    },
    isCipherTextValid() {
      return this.cipherText.length > 0
    },
    isNumOfWordsValid() {
      return this.numOfWords > 0 && (this.keyLength > 0 && this.numOfWords <= this.keyLength)
    }
  }
}
</script>